import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsWheelchairNormalSmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M6 9.325a2.675 2.675 0 100 5.35 2.675 2.675 0 000-5.35zm0 4a1.325 1.325 0 110-2.65 1.325 1.325 0 010 2.65z"
        fill=""
      />
      <path
        d="M20.5 11.325a3.157 3.157 0 00-2.484 1.222l-3.026-1.584a.592.592 0 01-.315-.523V9h-1.35v1.44c.004.309.082.613.228.885h-1.922a5.681 5.681 0 10-1.315 4.35h7.22v-.068a3.172 3.172 0 102.964-4.282zm-14.5 5a4.325 4.325 0 110-8.65 4.325 4.325 0 010 8.65zm11.343-2h-6.172a5.64 5.64 0 00.46-1.65h3.705v-.011l2.085 1.1a3.206 3.206 0 00-.078.561zm3.157 2a1.825 1.825 0 110-3.65 1.825 1.825 0 010 3.65z"
        fill=""
      />
    </svg>
  )
);
SvgSportsWheelchairNormalSmall.defaultProps = {
  color: 'currentColor',
  size: 24,
  title: undefined,
  titleId: undefined
};
SvgSportsWheelchairNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsWheelchairNormalSmall;
